<template>
  <Modal v-model="modal" width="1000" :styles="{top: fromListing ? '20px' : '100px'}" :title="$t('key1000077')">
    <div class="docx">
      <component :is="switchComponent"></component>
    </div>
    <template #footer>
      <Button @click="modal=false">{{ $t('key1000248') }}</Button>
    </template>
  </Modal>
</template>

<script>
import termsOfServiceCN from "@/views/shopping/common/termsOfServiceCN";
import termsOfServiceUS from "@/views/shopping/common/termsOfServiceUS";
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: 'termsOfService',
  mixins: [Mixin],
  components: {
    termsOfServiceCN,
    termsOfServiceUS
  },
  data() {
    return {
      modal: false
    };
  },
  computed: {
    fromListing() {
      return this.$store.state.fromListing;
    },
    switchComponent() {
      let component = this.languagesVal === 'zh-CN' ? termsOfServiceCN : termsOfServiceUS;
      return component;
    }
  },
  created() {

  },
  props: {},
  watch: {},
  methods: {}
};
</script>

<style scoped lang="less">
.docx {
  padding: 38px;
  background-color: #ffffff;
  color: #000;
  max-height: 600px;
  overflow-y: auto;
}
</style>
